import { useEffect, useRef, useState } from 'react';
import '../Home/Home.css'; 
import Header from '../Header/Header';
import CustomCursor from '../../CustomCursor';
import { GoArrowUpRight } from "react-icons/go";

const Test = () => {
    const scrollContainerRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);

    const handleWheel = (e) => {
        const container = scrollContainerRef.current;

        if (container) {
            e.preventDefault();

            container.scrollLeft += e.deltaY * 0.15; 

            const maxScrollLeft = container.scrollWidth / 2; 

            if (container.scrollLeft >= maxScrollLeft) {
                container.scrollLeft = container.scrollLeft - maxScrollLeft;
            } else if (container.scrollLeft < 0) {
                container.scrollLeft = maxScrollLeft + container.scrollLeft;
            }
        }
    };

    const handleTouchStart = (e) => {
        const container = scrollContainerRef.current;
        setIsDragging(true);
        setStartX(e.touches[0].pageX - container.offsetLeft);
        setScrollLeft(container.scrollLeft);
    };

    const handleTouchMove = (e) => {
        if (!isDragging) return;
        const container = scrollContainerRef.current;

        const x = e.touches[0].pageX - container.offsetLeft;
        const walk = (x - startX) * 1.2; 
        container.scrollLeft = scrollLeft - walk;

        const maxScrollLeft = container.scrollWidth / 2;

        if (container.scrollLeft >= maxScrollLeft) {
            container.scrollLeft = container.scrollLeft - maxScrollLeft;
        } else if (container.scrollLeft < 0) {
            container.scrollLeft = maxScrollLeft + container.scrollLeft;
        }
    };

    const handleTouchEnd = () => {
        setIsDragging(false);
    };

    useEffect(() => {
        const container = scrollContainerRef.current;
        if (container) {
            container.addEventListener('wheel', handleWheel, { passive: false });
            container.addEventListener('touchstart', handleTouchStart, { passive: true });
            container.addEventListener('touchmove', handleTouchMove, { passive: true });
            container.addEventListener('touchend', handleTouchEnd);
        }

        return () => {
            if (container) {
                container.removeEventListener('wheel', handleWheel);
                container.removeEventListener('touchstart', handleTouchStart);
                container.removeEventListener('touchmove', handleTouchMove);
                container.removeEventListener('touchend', handleTouchEnd);
            }
        };
    }, [isDragging, startX, scrollLeft]);


    const [isSectionVisible1, setIsSectionVisible1] = useState(false);
    const sectionRef1 = useRef(null);

    useEffect(() => {
        const currentSectionRef1 = sectionRef1.current;

        const observer1 = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsSectionVisible1(true);
                    } else {
                        setIsSectionVisible1(false);
                    }
                });
            },
            { threshold: 0.5 }
        );

        if (currentSectionRef1) {
            observer1.observe(currentSectionRef1);
        }

        return () => {
            if (currentSectionRef1) {
                observer1.unobserve(currentSectionRef1);
            }
        };
    }, []);

    const [isSectionVisible2, setIsSectionVisible2] = useState(false);
    const sectionRef2 = useRef(null);

    useEffect(() => {
        const currentSectionRef2 = sectionRef2.current;

        const observer2 = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsSectionVisible2(true);
                    } else {
                        setIsSectionVisible2(false);
                    }
                });
            },
            { threshold: 0.5 }
        );

        if (currentSectionRef2) {
            observer2.observe(currentSectionRef2);
        }

        return () => {
            if (currentSectionRef2) {
                observer2.unobserve(currentSectionRef2);
            }
        };
    }, []);

    const [isSectionVisible3, setIsSectionVisible3] = useState(false);
    const sectionRef3 = useRef(null);

    useEffect(() => {
        const currentSectionRef3 = sectionRef3.current;

        const observer3 = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsSectionVisible3(true);
                    } else {
                        setIsSectionVisible3(false);
                    }
                });
            },
            { threshold: 0.5 }
        );

        if (currentSectionRef3) {
            observer3.observe(currentSectionRef3);
        }

        return () => {
            if (currentSectionRef3) {
                observer3.unobserve(currentSectionRef3);
            }
        };
    }, []);

    const [isSectionVisible4, setIsSectionVisible4] = useState(false);
    const sectionRef4 = useRef(null);

    useEffect(() => {
        const currentSectionRef4 = sectionRef4.current;

        const observer4 = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsSectionVisible4(true);
                    } else {
                        setIsSectionVisible4(false);
                    }
                });
            },
            { threshold: 0.5 }
        );

        if (currentSectionRef4) {
            observer4.observe(currentSectionRef4);
        }

        return () => {
            if (currentSectionRef4) {
                observer4.unobserve(currentSectionRef4);
            }
        };
    }, []);

    const [isSectionVisible5, setIsSectionVisible5] = useState(false);
    const sectionRef5 = useRef(null);

    useEffect(() => {
        const currentSectionRef5 = sectionRef5.current;

        const observer5 = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsSectionVisible5(true);
                    } else {
                        setIsSectionVisible5(false);
                    }
                });
            },
            { threshold: 0.5 }
        );

        if (currentSectionRef5) {
            observer5.observe(currentSectionRef5);
        }

        return () => {
            if (currentSectionRef5) {
                observer5.unobserve(currentSectionRef5);
            }
        };
    }, []);

    const [isSectionVisible6, setIsSectionVisible6] = useState(false);
    const sectionRef6 = useRef(null);

    useEffect(() => {
        const currentSectionRef6 = sectionRef6.current;

        const observer6 = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsSectionVisible6(true);
                    } else {
                        setIsSectionVisible6(false);
                    }
                });
            },
            { threshold: 0.5 }
        );

        if (currentSectionRef6) {
            observer6.observe(currentSectionRef6);
        }

        return () => {
            if (currentSectionRef6) {
                observer6.unobserve(currentSectionRef6);
            }
        };
    }, []);

    const [isSectionVisible7, setIsSectionVisible7] = useState(false);
    const sectionRef7 = useRef(null);

    useEffect(() => {
        const currentSectionRef7 = sectionRef7.current;

        const observer7 = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsSectionVisible7(true);
                    } else {
                        setIsSectionVisible7(false);
                    }
                });
            },
            { threshold: 0.5 }
        );

        if (currentSectionRef7) {
            observer7.observe(currentSectionRef7);
        }

        return () => {
            if (currentSectionRef7) {
                observer7.unobserve(currentSectionRef7);
            }
        };
    }, []);

    const [isSectionVisible8, setIsSectionVisible8] = useState(false);
    const sectionRef8 = useRef(null);

    useEffect(() => {
        const currentSectionRef8 = sectionRef8.current;

        const observer8 = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsSectionVisible8(true);
                    } else {
                        setIsSectionVisible8(false);
                    }
                });
            },
            { threshold: 0.5 }
        );

        if (currentSectionRef8) {
            observer8.observe(currentSectionRef8);
        }

        return () => {
            if (currentSectionRef8) {
                observer8.unobserve(currentSectionRef8);
            }
        };
    }, []);

    const [isSectionVisible9, setIsSectionVisible9] = useState(false);
    const sectionRef9 = useRef(null);

    useEffect(() => {
        const currentSectionRef9 = sectionRef9.current;

        const observer9 = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsSectionVisible9(true);
                    } else {
                        setIsSectionVisible9(false);
                    }
                });
            },
            { threshold: 0.5 }
        );

        if (currentSectionRef9) {
            observer9.observe(currentSectionRef9);
        }

        return () => {
            if (currentSectionRef9) {
                observer9.unobserve(currentSectionRef9);
            }
        };
    }, []);

    const [isSectionVisible10, setIsSectionVisible10] = useState(false);
    const sectionRef10 = useRef(null);

    useEffect(() => {
        const currentSectionRef10 = sectionRef10.current;

        const observer10 = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsSectionVisible10(true);
                    } else {
                        setIsSectionVisible10(false);
                    }
                });
            },
            { threshold: 0.5 }
        );

        if (currentSectionRef10) {
            observer10.observe(currentSectionRef10);
        }

        return () => {
            if (currentSectionRef10) {
                observer10.unobserve(currentSectionRef10);
            }
        };
    }, []);

    const [isSectionVisible11, setIsSectionVisible11] = useState(false);
    const sectionRef11 = useRef(null);

    useEffect(() => {
        const currentSectionRef11 = sectionRef11.current;

        const observer11 = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsSectionVisible11(true);
                    } else {
                        setIsSectionVisible11(false);
                    }
                });
            },
            { threshold: 0.5 }
        );

        if (currentSectionRef11) {
            observer11.observe(currentSectionRef11);
        }

        return () => {
            if (currentSectionRef11) {
                observer11.unobserve(currentSectionRef11);
            }
        };
    }, []);

    const [isSectionVisible12, setIsSectionVisible12] = useState(false);
    const sectionRef12 = useRef(null);

    useEffect(() => {
        const currentSectionRef12 = sectionRef12.current;

        const observer12 = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsSectionVisible12(true);
                    } else {
                        setIsSectionVisible12(false);
                    }
                });
            },
            { threshold: 0.5 }
        );

        if (currentSectionRef12) {
            observer12.observe(currentSectionRef12);
        }

        return () => {
            if (currentSectionRef12) {
                observer12.unobserve(currentSectionRef12);
            }
        };
    }, []);

    const [isSectionVisible13, setIsSectionVisible13] = useState(false);
    const sectionRef13 = useRef(null);

    useEffect(() => {
        const currentSectionRef13 = sectionRef13.current;

        const observer13 = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsSectionVisible13(true);
                    } else {
                        setIsSectionVisible13(false);
                    }
                });
            },
            { threshold: 0.5 }
        );

        if (currentSectionRef13) {
            observer13.observe(currentSectionRef13);
        }

        return () => {
            if (currentSectionRef13) {
                observer13.unobserve(currentSectionRef13);
            }
        };
    }, []);

    return (
        <div className='text-[14px] md:text-xl lg:text-[17px] 2xl:text-xl leading-7 md:leading-8 lg:leading-7 2xl:leading-10'>
            <Header />
            {/* <VerticalFooter /> */}
            <CustomCursor />
            <div
                className="scroll-container"
                ref={scrollContainerRef}
                style={{ overflowX: 'auto', display: 'flex', width: '100vw', height: '100vh' }}
            >
                {/* Original content */}
                <div className="scroll-content relative" style={{ background: 'teal' }}>
                    <img src="../assets/photography_bg.png" alt="Img" className="absolute inset-0 w-full h-full object-cover" />

                    <div className="relative flex flex-col mx-[5%] justify-between z-10 h-3/4 w-full text-white">
                        <div className='flex ml-[45%] lg:ml-[70%] mt-[5%]'>At Open Studios, we believe .</div>
                        <a href='/' className='heading text-6xl md:text-8xl lg:text-9xl 2xl:text-[10rem]'>
                            <span className='btn-shine_clickBeyond_btn'>Click Beyond</span>
                        </a>

                    </div>
                </div>


                <div className="scroll-content" style={{ background: 'orange' }}>
                    <div className='grid grid-cols-1 lg:grid-cols-2 w-full h-full lg:h-[84%] lg:mt-[6%] mx-[5%] lg:mx-[2%]'>

                        <div className='flex flex-col justify-between lg:border-r-2 lg:border-b-0 border-gray-300 lg:pr-[5%]'>
                            <div className='flex justify-between' ref={sectionRef1}>
                                <p>Introduction</p>
                                <img src="../assets/gray_rect.png" alt="Img" className={`h-[30vh] lg:h-[40vh] transition-transform duration-1000 ${isSectionVisible1 ? 'scale-100' : 'scale-50'}`} />
                            </div>

                            <div className=''>
                                <p className='text-2xl md:text-3xl lg:text-4xl'>Established 2015</p>
                                <p className='mt-[5%] lg:mt-[2%]'>At Open Studios, we believe that every great.</p>

                                <div className='flex justify-start mt-[5%] lg:mt-[2%]'>
                                    <div className='joint_btn arrow_btn-wrapper bg-[#F56E0F] py-[0.2%] px-[2.5%] lg:px-[1.5%] rounded-full cursor-pointer'>Learn more about us</div>
                                    <div style={{ '--clr': '#F56E0F' }} className="arrow_btn cursor-pointer">
                                        <span className="arrow_btn__icon-wrapper_white">
                                            <svg width="10" className="arrow_btn__icon-svg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 15">
                                                <path fill="currentColor" d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"></path>
                                            </svg>
                                            <svg className="arrow_btn__icon-svg arrow_btn__icon-svg--copy" xmlns="http://www.w3.org/2000/svg" width="10" fill="none" viewBox="0 0 14 15">
                                                <path fill="currentColor" d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"></path>
                                            </svg>
                                        </span>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className='hidden lg:block lg:pl-[5%]' ref={sectionRef2}>
                            <img src="../assets/gray_rect.png" alt="Img" className={`h-[72vh] w-full transition-transform duration-1000 ${isSectionVisible2 ? 'scale-100' : 'scale-75'}`} />

                            <p className='mt-[5%] lg:mt-[2%] font-semibold'>Project 1</p>

                            <div className='flex justify-start mt-[5%] lg:mt-[2%]'>
                                <div className='joint_btn arrow_btn-wrapper bg-[#F56E0F] py-[0.2%] px-[2.5%] lg:px-[1.5%] rounded-full cursor-pointer'>Learn more about us</div>
                                <div style={{ '--clr': '#F56E0F' }} className="arrow_btn cursor-pointer">
                                    <span className="arrow_btn__icon-wrapper_white">
                                        <svg width="10" className="arrow_btn__icon-svg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 15">
                                            <path fill="currentColor" d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"></path>
                                        </svg>
                                        <svg className="arrow_btn__icon-svg arrow_btn__icon-svg--copy" xmlns="http://www.w3.org/2000/svg" width="10" fill="none" viewBox="0 0 14 15">
                                            <path fill="currentColor" d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"></path>
                                        </svg>
                                    </span>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>


                <div className="scroll-content" style={{ background: 'purple' }}>
                    <div className='flex flex-col justify-between w-full h-full lg:h-[84%] lg:mt-[6%] mx-[5%]' ref={sectionRef3}>
                        <img src="../assets/gray_rect.png" alt="Img" className={`h-[65.5vh] lg:h-[72vh] w-full transition-transform duration-1000 ${isSectionVisible3 ? 'scale-100' : 'scale-75'}`} />

                        <div>
                            <p className='font-semibold'>Project 1</p>

                            <div className='flex justify-start mt-[5%] lg:mt-[2%]'>
                                <div className='joint_btn arrow_btn-wrapper bg-[#F56E0F] py-[0.2%] px-[2.5%] lg:px-[1.5%] rounded-full cursor-pointer'>Learn more about us</div>
                                <div style={{ '--clr': '#F56E0F' }} className="arrow_btn cursor-pointer">
                                    <span className="arrow_btn__icon-wrapper_white">
                                        <svg width="10" className="arrow_btn__icon-svg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 15">
                                            <path fill="currentColor" d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"></path>
                                        </svg>
                                        <svg className="arrow_btn__icon-svg arrow_btn__icon-svg--copy" xmlns="http://www.w3.org/2000/svg" width="10" fill="none" viewBox="0 0 14 15">
                                            <path fill="currentColor" d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"></path>
                                        </svg>
                                    </span>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>


                <div className="scroll-content" style={{ background: 'green' }} ref={sectionRef4}>
                    <div className='grid grid-cols-1 lg:grid-cols-2 w-full h-full lg:h-[84%] lg:mt-[6%] mx-[5%] lg:mx-[2%] lg:border-r-2 lg:border-b-0 border-gray-300 lg:pr-[2%]'>

                        <div className='flex flex-col lg:pr-[5%]'>
                            <img src="../assets/gray_rect.png" alt="Img" className={`h-[65.5vh] lg:h-[72vh] w-full transition-transform duration-1000 ${isSectionVisible4 ? 'scale-100' : 'scale-75'}`} />

                            <p className='mt-[1%] lg:mt-[2%] font-semibold'>Project 2</p>

                            <div className='flex justify-start mt-[5%] lg:mt-[2%]'>
                                <div className='joint_btn arrow_btn-wrapper bg-[#F56E0F] py-[0.2%] px-[2.5%] lg:px-[1.5%] rounded-full cursor-pointer'>Learn more about us</div>
                                <div style={{ '--clr': '#F56E0F' }} className="arrow_btn cursor-pointer">
                                    <span className="arrow_btn__icon-wrapper_white">
                                        <svg width="10" className="arrow_btn__icon-svg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 15">
                                            <path fill="currentColor" d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"></path>
                                        </svg>
                                        <svg className="arrow_btn__icon-svg arrow_btn__icon-svg--copy" xmlns="http://www.w3.org/2000/svg" width="10" fill="none" viewBox="0 0 14 15">
                                            <path fill="currentColor" d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"></path>
                                        </svg>
                                    </span>
                                </div>
                            </div>

                        </div>

                        <div className='hidden lg:block' ref={sectionRef5}>
                            <img src="../assets/gray_rect.png" alt="Img" className={`h-[72vh] w-full transition-transform duration-1000 ${isSectionVisible5 ? 'scale-100' : 'scale-75'}`} />

                            <p className='mt-[8%] lg:mt-[2%] font-semibold'>Project 3</p>

                            <div className='flex justify-start mt-[5%] lg:mt-[2%]'>
                                <div className='joint_btn arrow_btn-wrapper bg-[#F56E0F] py-[0.2%] px-[2.5%] lg:px-[1.5%] rounded-full cursor-pointer'>Learn more about us</div>
                                <div style={{ '--clr': '#F56E0F' }} className="arrow_btn cursor-pointer">
                                    <span className="arrow_btn__icon-wrapper_white">
                                        <svg width="10" className="arrow_btn__icon-svg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 15">
                                            <path fill="currentColor" d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"></path>
                                        </svg>
                                        <svg className="arrow_btn__icon-svg arrow_btn__icon-svg--copy" xmlns="http://www.w3.org/2000/svg" width="10" fill="none" viewBox="0 0 14 15">
                                            <path fill="currentColor" d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"></path>
                                        </svg>
                                    </span>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                {/* Duplicate content to create the infinite scroll effect */}
                <div className="scroll-content" style={{ background: 'yellow' }} ref={sectionRef6}>
                    <div className='flex flex-col justify-between w-full h-full lg:h-[84%] lg:mt-[6%] mx-[5%]'>
                        <img src="../assets/gray_rect.png" alt="Img" className={`h-[66vh] w-full transition-transform duration-1000 ${isSectionVisible6 ? 'scale-100' : 'scale-75'}`} />

                        <div>
                            <p className='font-semibold'>Project 3</p>

                            <div className='flex justify-start mt-[5%] lg:mt-[2%]'>
                                <div className='joint_btn arrow_btn-wrapper bg-[#F56E0F] py-[0.2%] px-[2.5%] lg:px-[1.5%] rounded-full cursor-pointer'>Learn more about us</div>
                                <div style={{ '--clr': '#F56E0F' }} className="arrow_btn cursor-pointer">
                                    <span className="arrow_btn__icon-wrapper_white">
                                        <svg width="10" className="arrow_btn__icon-svg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 15">
                                            <path fill="currentColor" d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"></path>
                                        </svg>
                                        <svg className="arrow_btn__icon-svg arrow_btn__icon-svg--copy" xmlns="http://www.w3.org/2000/svg" width="10" fill="none" viewBox="0 0 14 15">
                                            <path fill="currentColor" d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"></path>
                                        </svg>
                                    </span>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>


                <div className="scroll-content" style={{ background: 'skyblue' }}>
                    <div className='grid grid-cols-1 lg:grid-cols-2 w-full h-full lg:h-[84%] lg:mt-[6%] mx-[5%] lg:mx-[2%]'>

                        <div className='flex flex-col justify-between'>

                            <p className='text-center'>What we do</p>
                            <p className='heading text-2xl md:text-3xl lg:text-4xl 2xl:text-5xl text-center lg:mx-[10%] 2xl:mx-[15%]'>At Open Studios, we believe that every
                                great idea deserves the perfect platform to thrive. As a team of passionate creatives, tech enthusiasts, and strategic
                                thinkers, we are dedicated to transforming your vision into reality.</p>

                            <div className='flex justify-center'>
                                <button className="group relative h-[7em] w-[7em] lg:h-[9em] lg:w-[9em] hover:scale-90 z-10 transition-transform duration-300 rounded-full hover:bg-black hover:bg-opacity-10">
                                    <img
                                        src="../assets/black_circularText.png"
                                        alt="Circular Text"
                                        className="absolute inset-0 h-full w-full object-cover custom_spin"
                                    />
                                    <GoArrowUpRight className="absolute inset-0 m-auto text-[2em] lg:text-[3em] flex justify-center items-center" />
                                </button>
                            </div>

                        </div>

                        <div className='hidden lg:block' ref={sectionRef7}>
                            <img src="../assets/gray_rect.png" alt="Img" className={`h-[66vh] lg:h-[83vh] w-full transition-transform duration-1000 ${isSectionVisible7 ? 'scale-100' : 'scale-75'}`} />
                        </div>

                    </div>
                </div>


                <div className="scroll-content" style={{ background: 'red' }}>
                    <div className='w-full h-full lg:h-[84%] lg:mt-[6%] mx-[5%] lg:mx-[2%]' ref={sectionRef8}>
                        <img src="../assets/gray_rect.png" alt="Img" className={`h-full transition-transform duration-1000 ${isSectionVisible8 ? 'scale-100' : 'scale-75'}`} />
                    </div>
                </div>


                <div className="scroll-content" style={{ background: 'brown' }}>
                    <div className='flex flex-col justify-between bg-[#F56E0F] text-white w-full h-full lg:h-[84%] lg:mt-[6%] px-[5%] lg:px-[2%]'>

                        <div>
                            <p className='text-2xl md:text-3xl lg:text-4xl lg:w-[55%]'>In tune with London's fast changing markets, Studio RHE combine commercial know how with creative originality.</p>

                            <div className='flex justify-start mt-[5%] lg:mt-[2%]'>
                                <div className='joint_btn_orange arrow_btn-wrapper_orange bg-white text-black py-[0.2%] px-[2.5%] lg:px-[1.5%] rounded-full cursor-pointer'>
                                    Learn more about us
                                </div>
                                <div style={{ '--clr': 'white' }} className="arrow_btn_orange cursor-pointer">
                                    <span className="arrow_btn__icon-wrapper_orange">
                                        <svg width="10" className="arrow_btn__icon-svg_orange" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 15">
                                            <path fill="currentColor" d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"></path>
                                        </svg>
                                        <svg className="arrow_btn__icon-svg_orange arrow_btn__icon-svg--copy_orange" xmlns="http://www.w3.org/2000/svg" width="10" fill="none" viewBox="0 0 14 15">
                                            <path fill="currentColor" d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"></path>
                                        </svg>
                                    </span>
                                </div>
                            </div>

                        </div>

                        <p className='heading text-6xl md:text-8xl lg:text-9xl 2xl:text-[10rem]'>ABCD XYZ</p>

                    </div>
                </div>


                <div className="scroll-content" style={{ background: 'pink' }}>
                    <div className='grid grid-cols-1 lg:grid-cols-2 w-full h-full lg:h-[84%] lg:mt-[6%] mx-[5%] lg:mx-[2%]'>

                        <div className='flex flex-col justify-between lg:pr-[5%]' ref={sectionRef9}>
                            <img src="../assets/gray_rect.png" alt="Img" className={`h-[66vh] lg:h-[72vh] w-full transition-transform duration-1000 ${isSectionVisible9 ? 'scale-100' : 'scale-75'}`} />

                            <div>
                                <p className='font-semibold'>Project 4</p>

                                <div className='flex justify-start mt-[5%] lg:mt-[2%]'>
                                    <div className='joint_btn arrow_btn-wrapper bg-[#F56E0F] py-[0.2%] px-[2.5%] lg:px-[1.5%] rounded-full cursor-pointer'>Learn more about us</div>
                                    <div style={{ '--clr': '#F56E0F' }} className="arrow_btn cursor-pointer">
                                        <span className="arrow_btn__icon-wrapper_white">
                                            <svg width="10" className="arrow_btn__icon-svg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 15">
                                                <path fill="currentColor" d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"></path>
                                            </svg>
                                            <svg className="arrow_btn__icon-svg arrow_btn__icon-svg--copy" xmlns="http://www.w3.org/2000/svg" width="10" fill="none" viewBox="0 0 14 15">
                                                <path fill="currentColor" d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"></path>
                                            </svg>
                                        </span>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className='hidden lg:block'>
                            <div ref={sectionRef10}>
                                <img src="../assets/gray_rect.png" alt="Img" className={`h-[28vh] w-full transition-transform duration-1000 ${isSectionVisible10 ? 'scale-100' : 'scale-75'}`} />

                                <p className='mt-[5%] lg:mt-[2%] font-semibold'>Project 5</p>

                                <div className='flex justify-start mt-[5%] lg:mt-[2%]'>
                                    <div className='joint_btn arrow_btn-wrapper bg-[#F56E0F] py-[0.2%] px-[2.5%] lg:px-[1.5%] rounded-full cursor-pointer'>Learn more about us</div>
                                    <div style={{ '--clr': '#F56E0F' }} className="arrow_btn cursor-pointer">
                                        <span className="arrow_btn__icon-wrapper_white">
                                            <svg width="10" className="arrow_btn__icon-svg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 15">
                                                <path fill="currentColor" d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"></path>
                                            </svg>
                                            <svg className="arrow_btn__icon-svg arrow_btn__icon-svg--copy" xmlns="http://www.w3.org/2000/svg" width="10" fill="none" viewBox="0 0 14 15">
                                                <path fill="currentColor" d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"></path>
                                            </svg>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className='mt-[8%] lg:mt-[4%]' ref={sectionRef11}>
                                <img src="../assets/gray_rect.png" alt="Img" className={`h-[28vh] w-full transition-transform duration-1000 ${isSectionVisible11 ? 'scale-100' : 'scale-75'}`} />

                                <p className='mt-[5%] lg:mt-[2%] font-semibold'>Project 6</p>

                                <div className='flex justify-start mt-[5%] lg:mt-[2%]'>
                                    <div className='joint_btn arrow_btn-wrapper bg-[#F56E0F] py-[0.2%] px-[2.5%] lg:px-[1.5%] rounded-full cursor-pointer'>Learn more about us</div>
                                    <div style={{ '--clr': '#F56E0F' }} className="arrow_btn cursor-pointer">
                                        <span className="arrow_btn__icon-wrapper_white">
                                            <svg width="10" className="arrow_btn__icon-svg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 15">
                                                <path fill="currentColor" d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"></path>
                                            </svg>
                                            <svg className="arrow_btn__icon-svg arrow_btn__icon-svg--copy" xmlns="http://www.w3.org/2000/svg" width="10" fill="none" viewBox="0 0 14 15">
                                                <path fill="currentColor" d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"></path>
                                            </svg>
                                        </span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>


                <div className="scroll-content" style={{ background: 'gold' }}>
                    <div className='flex flex-col justify-between w-full h-full lg:h-[84%] lg:mt-[6%] mx-[5%] lg:mx-[2%]'>
                        <div ref={sectionRef12}>
                            <img src="../assets/gray_rect.png" alt="Img" className={`h-[23vh] w-full transition-transform duration-1000 ${isSectionVisible12 ? 'scale-100' : 'scale-50'}`} />

                            <p className='mt-[5%] lg:mt-[2%] font-semibold'>Project 5</p>

                            <div className='flex justify-start mt-[5%] lg:mt-[2%]'>
                                <div className='joint_btn arrow_btn-wrapper bg-[#F56E0F] py-[0.2%] px-[2.5%] lg:px-[1.5%] rounded-full cursor-pointer'>Learn more about us</div>
                                <div style={{ '--clr': '#F56E0F' }} className="arrow_btn cursor-pointer">
                                    <span className="arrow_btn__icon-wrapper_white">
                                        <svg width="10" className="arrow_btn__icon-svg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 15">
                                            <path fill="currentColor" d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"></path>
                                        </svg>
                                        <svg className="arrow_btn__icon-svg arrow_btn__icon-svg--copy" xmlns="http://www.w3.org/2000/svg" width="10" fill="none" viewBox="0 0 14 15">
                                            <path fill="currentColor" d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"></path>
                                        </svg>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className='mt-[8%] lg:mt-[4%]' ref={sectionRef13}>
                            <img src="../assets/gray_rect.png" alt="Img" className={`h-[23vh] w-full transition-transform duration-1000 ${isSectionVisible13 ? 'scale-100' : 'scale-50'}`} />

                            <p className='mt-[5%] lg:mt-[2%] font-semibold'>Project 6</p>

                            <div className='flex justify-start mt-[5%] lg:mt-[2%]'>
                                <div className='joint_btn arrow_btn-wrapper bg-[#F56E0F] py-[0.2%] px-[2.5%] lg:px-[1.5%] rounded-full cursor-pointer'>Learn more about us</div>
                                <div style={{ '--clr': '#F56E0F' }} className="arrow_btn cursor-pointer">
                                    <span className="arrow_btn__icon-wrapper_white">
                                        <svg width="10" className="arrow_btn__icon-svg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 15">
                                            <path fill="currentColor" d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"></path>
                                        </svg>
                                        <svg className="arrow_btn__icon-svg arrow_btn__icon-svg--copy" xmlns="http://www.w3.org/2000/svg" width="10" fill="none" viewBox="0 0 14 15">
                                            <path fill="currentColor" d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"></path>
                                        </svg>
                                    </span>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>


                <div className="scroll-content" style={{ background: 'violet' }}>
                    <h1>Item 4 (Duplicate)</h1>
                    <p>This is a duplicate of Item 4 for the infinite loop effect.</p>
                </div>


                <div className="scroll-content" style={{ background: 'brown' }}>
                    <h1>Item 2 (Duplicate)</h1>
                    <p>This is a duplicate of Item 2 for the infinite loop effect.</p>
                </div>
                <div className="scroll-content" style={{ background: 'red' }}>
                    <h1>Item 3 (Duplicate)</h1>
                    <p>This is a duplicate of Item 3 for the infinite loop effect.</p>
                </div>
                <div className="scroll-content" style={{ background: 'black' }}>
                    <h1>Item 4 (Duplicate)</h1>
                    <p>This is a duplicate of Item 4 for the infinite loop effect.</p>
                </div>
                <div className="scroll-content" style={{ background: 'brown' }}>
                    <h1>Item 2 (Duplicate)</h1>
                    <p>This is a duplicate of Item 2 for the infinite loop effect.</p>
                </div>
                <div className="scroll-content" style={{ background: 'red' }}>
                    <h1>Item 3 (Duplicate)</h1>
                    <p>This is a duplicate of Item 3 for the infinite loop effect.</p>
                </div>
                <div className="scroll-content" style={{ background: 'brown' }}>
                    <h1>Item 2 (Duplicate)</h1>
                    <p>This is a duplicate of Item 2 for the infinite loop effect.</p>
                </div>
                <div className="scroll-content" style={{ background: 'red' }}>
                    <h1>Item 3 (Duplicate)</h1>
                    <p>This is a duplicate of Item 3 for the infinite loop effect.</p>
                </div>
            </div>
        </div>
    );
};

export default Test;
